var render = function render(){var _vm=this,_c=_vm._self._c;return _c('smart-link',{attrs:{"to":_vm.to}},[_c('button',{staticClass:"component-button",on:{"click":_vm.onClick}},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"plus"},[_c('span',{staticClass:"v"}),_c('span',{staticClass:"h"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }